import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelSnapshotSpiderDashboardRoute from 'lumen/routes/hotel/snapshot/spider-dashboard';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSnapshotSpiderDashboardController extends Controller {
  declare model: ModelFrom<HotelSnapshotSpiderDashboardRoute>;

  queryParams = [
    'asofDailyDate',
    'asofDate',
    'data_replatforming',
    'endDate',
    'heatmapFilter',
    'heatmapMode',
    'heatmapYear',
    'lastYearMode',
    'pickupFrom',
    'showVariance',
    'startDate',
    'tooltipHierarchy',
    'withGroupRemaining',
    'year',
  ];

  @service declare currency: Services['currency'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  declare dashboard: string;

  get iframeQPs(): Record<string, unknown> {
    const iframeQPs: Record<string, unknown> = {
      iframe: 1,
      origin: window.location.origin,
    };

    if (this.currency.selectedCurrency) {
      iframeQPs['currency'] = this.currency.selectedCurrency;
    }

    if (this.currencyConversion.selectedProfileId) {
      iframeQPs['currencyVariant'] = this.currencyConversion.selectedProfileId;
    }

    if (this.hotelAndMarketService.hotel) {
      iframeQPs['subscriptionId'] = this.hotelAndMarketService.hotel.id;
    }

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = this[queryParam]!;

      if (value) {
        iframeQPs[queryParam] = value;
      }
    });

    return iframeQPs;
  }

  get urlForEmbeddedApp(): string {
    const { dashboard, model } = this;

    // @ts-expect-error: Incorrect type
    return `/dashboards/hotel-snapshot/${model.spiderId}/${dashboard}`;
  }

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      this[queryParam] = null;
    });
  }
}
